import $ from 'jquery';
import ReviewsSorting from '../components/ReviewsSorting';

class ReviewsPage {
	constructor() {
		this.init();
	}

	init() {
		new ReviewsSorting();
		this.initProgressBar();
	}

	initProgressBar() {
		$('.progressbar-status').each(function() {
			$(this).animate({
				'width': $(this).attr('data-fill')
			}, 1000);
		});
	}
}

new ReviewsPage();